import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {
	FaqListSelection,
	faqListSelectionPortableTextOverrides,
} from '../../components/faq-list-selection';

import type {FaqListSelectionFragment} from './query';

type Props = {
	data: FaqListSelectionFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const FaqListSelectionContainer = ({data, fullWidth, anchorHeadings, insideToc}: Props) => {
	const {contentBlockOptions, faqs, heading, description} = data;

	return (
		<FaqListSelection
			faqs={faqs?.map((faq) => ({
				question: faq.question ?? '',
				_key: faq._id,
				answer:
					faq.answer && faq.answer.length > 0 ? (
						<PortableText value={faq.answer} />
					) : null,
				areas: faq.areas?.map((area) => area.slug ?? '') ?? [],
				fieldOfAreas: faq.fieldOfAreas?.map((area) => area.slug ?? '') ?? [],
			}))}
			heading={heading ?? ''}
			description={
				description && description.length > 0 ? (
					<PortableText
						value={description}
						overrideClassNames={faqListSelectionPortableTextOverrides}
					/>
				) : null
			}
			anchorHeadings={anchorHeadings}
			options={{
				fullWidth,
				...contentBlockOptions,
			}}
			insideToc={insideToc}
		/>
	);
};
